interface UpdateItem {
  date: string;
  tag: string;
  title: string;
  summary: string;
}

const updates: UpdateItem[] = [
  {
    date: '08-01',
    tag: '上新',
    title: '《星落长河》大结局今日上线',
    summary: '年度古装巨制迎来大结局，全集48集一次性放出，熬夜党福利来了。',
  },
  {
    date: '07-31',
    tag: '热播',
    title: '《暗夜追踪》第32集更新',
    summary: '悬疑剧情再掀高潮，真相逐渐浮出水面，本集信息量爆表。',
  },
  {
    date: '07-30',
    tag: '预告',
    title: '《都市夜话》第二季定档8月15日',
    summary: '原班人马回归，新一季将聚焦都市青年的职场与情感故事。',
  },
  {
    date: '07-29',
    tag: '完结',
    title: '《风起云涌》全剧终 评分9.2',
    summary: '这部口碑爆款剧集画上句号，网友纷纷表示不舍，期待番外篇。',
  },
  {
    date: '07-28',
    tag: '上新',
    title: '韩剧《月之恋人》中字全集上线',
    summary: '浪漫奇幻题材，男女主角化学反应爆棚，一口气刷完16集。',
  },
  {
    date: '07-27',
    tag: '活动',
    title: '暑期追剧季：每日签到领会员',
    summary: '连续签到7天即可获得VIP体验资格，畅享更高清画质。',
  },
  {
    date: '07-26',
    tag: '修复',
    title: '部分剧集播放卡顿问题已修复',
    summary: '服务器全面升级完成，所有线路恢复流畅播放，感谢大家耐心等待。',
  },
  {
    date: '07-25',
    tag: '上新',
    title: '美剧《边缘世界》第三季独家上线',
    summary: '科幻烧脑神剧回归，夜猫影院国内首批同步更新中文字幕版。',
  },
  {
    date: '07-24',
    tag: '公告',
    title: 'APP端3.0版本发布，新增夜间模式',
    summary: '专为夜猫子设计的深色主题，保护视力同时提升观影沉浸感。',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          最新动态
        </h2>
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2 hidden md:block"></div>
          <div className="space-y-6 md:space-y-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className={`md:mt-4 ${idx % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                    <div className="flex items-center gap-2 md:justify-end mb-2">
                      <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${
                        item.tag === '上新' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '热播' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '完结' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-background-200 text-foreground-500'
                      }`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
                  </div>
                </div>
                <div className="hidden md:flex items-center justify-center w-8 shrink-0">
                  <div className={`w-3 h-3 rounded-full border-2 ${
                    item.tag === '上新' ? 'bg-primary-500 border-primary-500' :
                    item.tag === '热播' ? 'bg-accent-500 border-accent-500' :
                    'bg-background-50 border-background-300'
                  }`}></div>
                </div>
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}